import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { InputText } from 'primereact/inputtext';
import { useEffect, useRef, useState } from 'react';
import { getInputValue, setInputValue } from '../../util/refUtils';
import { crearDuenoSiniestro, eliminarDuenoSiniestro, modificarDuenoSiniestro } from '../../services/Siniestro/SiniestroService';
import AsignaRutas from './AsignaRutas';

const NuevoProyecto = ({ toast, clienteDat, funcSalir, datProyecto }) => {
    const refNombrePro = useRef('');

    const [grabando, setGrabando] = useState(false);
    const [verRutas, setVerRutas] = useState(false);
    const [eliminando, setEliminando] = useState(false);
    const [confEliminar, setConfEliminar] = useState(false);

    useEffect(() => {
        const inicial = () => {
            if (datProyecto?.configuracionDetId) {
                setInputValue(refNombrePro, datProyecto?.nombre);
            }
        };
        inicial();
    }, [datProyecto]);

    const handleGuardar = async () => {
        const valProyecto = getInputValue(refNombrePro);
        if (!valProyecto) {
            toast.current.show({
                severity: 'warn',
                summary: 'Atencion',
                detail: 'Debe llenar el campo Nombre.'
            });
            return;
        }
        //console.log('GRABANDO EL PROYECTO');
        try {
            setGrabando(true);
            const CODE_CONFIGCAB_PROYECTO = 'SIN-0000-0003';
            const objPost = {
                configuracionCabId: 0,
                padreConfiguracionDetId: clienteDat?.configuracionDetId,
                codigo: 'nuevo',
                nombre: valProyecto
            };
            let datos;
            if (datProyecto?.configuracionDetId) {
                objPost['configuracionDetId'] = datProyecto?.configuracionDetId;
                datos = await modificarDuenoSiniestro(objPost, CODE_CONFIGCAB_PROYECTO);
            } else {
                datos = await crearDuenoSiniestro(objPost, CODE_CONFIGCAB_PROYECTO);
            }
            if (datos?.configuracionDetId) {
                toast.current.show({
                    severity: 'success',
                    summary: 'Exito',
                    detail: 'Se ha registrado el Proyecto.'
                });
            }
        } catch (error) {
            console.error('ERROR: Error al creaar el Proyecto');
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Error al registrar el Proyecto.'
            });
        } finally {
            setGrabando(false);
            funcSalir();
        }
    };

    const mostrarRutas = () => setVerRutas(true);
    const ocultarRutas = () => setVerRutas(false);

    const pedirEliminar = () => setConfEliminar(true);

    const confirmarEliminar = async () => {
        if (!datProyecto?.configuracionDetId) return;
        try {
            setEliminando(true);
            await eliminarDuenoSiniestro(datProyecto.configuracionDetId);
            toast.current.show({
                severity: 'success',
                summary: 'Exito',
                detail: 'Proyecto eliminado.'
            });
            setConfEliminar(false);
            funcSalir();
        } catch (error) {
            console.error('ERROR: Error al eliminar el Proyecto');
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Error al eliminar el Proyecto.'
            });
        } finally {
            setEliminando(false);
        }
    };

    return (
        <div className="card">
            <Dialog visible={verRutas} onHide={() => setVerRutas(false)} header="Asignar Rutas al Proyecto" style={{ width: '60vw' }}>
                <AsignaRutas datPuesto={datProyecto} funcSalir={ocultarRutas} />
            </Dialog>
            <div className="formgrid grid p-fluid mb-3">
                <div className="field col-12 md:col-4">
                    <label>Nombre Cliente:</label>
                </div>
                <div className="field col-12 md:col-8">
                    <span className="inline-block w-full bg-gray-100 border border-gray-300 text-gray-600 p-2 rounded-md text-base shadow-inner">
                        {clienteDat.nombre}
                    </span>
                </div>
                <div className="field col-12 md:col-12">
                    <label>Nombre del Proyecto</label>
                    <InputText
                        ref={refNombrePro}
                        defaultValue=""
                        onInput={(e) => (e.target.value = e.target.value.toUpperCase())}
                        maxLength={100}
                    />
                </div>
                <div className="field col-12 md:col-3">
                    <Button
                        label="Asignar Rutas"
                        className="p-button-warning"
                        icon="pi pi-map"
                        onClick={mostrarRutas}
                        disabled={!datProyecto?.configuracionDetId}
                    />
                </div>
                <div className="field col-12 md:col-3">
                    <label style={{ visibility: 'hidden' }}>Texto oculto</label>
                </div>
                <div className="field col-12 md:col-3">
                    <Button
                        label="Eliminar"
                        className="p-button-danger"
                        icon="pi pi-trash"
                        disabled={!datProyecto?.configuracionDetId}
                        onClick={pedirEliminar}
                        loading={eliminando}
                    />
                </div>
                <div className="field col-12 md:col-3">
                    <Button
                        label="Guardar"
                        className="p-button-primary"
                        icon="pi pi-save"
                        onClick={handleGuardar}
                        loading={grabando}
                    />
                </div>
            </div>
            <ConfirmDialog
                visible={confEliminar}
                onHide={() => setConfEliminar(false)}
                message={`¿Confirma eliminar el proyecto "${datProyecto?.nombre}"?`}
                header="Eliminar Proyecto"
                icon="pi pi-exclamation-triangle"
                acceptLabel="Si"
                rejectLabel="No"
                acceptClassName="p-button-danger"
                accept={confirmarEliminar}
            />
        </div>
    );
};

export default NuevoProyecto;
